var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.61523 1.32617C7.76215 0.991062 8.23785 0.991061 8.38477 1.32617L9.24316 3.29004C10.1472 5.356 13.0198 5.50882 14.1387 3.55078C14.289 3.28808 14.691 3.40984 14.6709 3.71191L14.0771 12.6172C14.0038 13.7159 13.1781 14.6166 12.0898 14.7842C9.37941 15.2012 6.62059 15.2012 3.91016 14.7842C2.82187 14.6166 1.99617 13.7159 1.92285 12.6172L1.3291 3.71191C1.30896 3.40984 1.71102 3.28808 1.86133 3.55078C2.98021 5.50882 5.85278 5.356 6.75684 3.29004L7.61523 1.32617Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.16,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.5C5.5 11.5 10.5 11.5 14 10.5",
    stroke: "black",
    strokeWidth: 1.16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel);
export default __webpack_public_path__ + "static/media/level.735a92b323dcc0c1b6f911c684dd7921.svg";
export { ForwardRef as ReactComponent };